import { create, updateField, updateFields, update, remove, getById, getAll, getBySingleQuery } from '../utils/dbUtils';
import { isBooleanTrue, isBooleanFalse, isListNotEmpty, isNotNullOrUndefined, isNumberGreaterThanOrEqualToZero, isObjectNotEmpty, isStringEmpty, isStringNotEmpty, isStringNotEmptyOrZeroLength } from "../utils/objectUtils";
import StatusHistory from './StatusHistory';
import { asTimeZone } from "../utils/dateFormatter";

import moment from 'moment-timezone';
import { toLower } from 'lodash';
import { db, loadStorage } from "../firebase";
import { collection, endBefore, getCountFromServer, getDocs, limit, limitToLast, orderBy, query, startAfter, where } from "firebase/firestore";
import { v4 as uuid } from 'uuid';

class Event {
    static collectionName = 'events';

    groupId = null;
    parentEventId = null; // id of the parent event
    checkInId = null; // id of the checkIn form
    surveyId = null; // id of the survey form

    breakoutGroupIds = []; // list of ids of breakout groups
    childEventIds = []; // list of child event ids

    participantIds = []; // userIds of the customers
    hostIds = []; // userIds of the hosts

    reviewIds = [];
    socialIds = []; // list of ids to social media

    location = null;

    lastMessageAt = null;
    lastMessageBy = null;
    isRead = false;
    unreadCount = 0;
    messagesCount = 0;
    messages = []; // array of ChatMessage

    eventNotificationIds = []; // list of ids to notifications

    eventType = null; // enum EventTypes SESSION, WEBINAR, CONFERENCE, WORKSHOP, OTHER
    name = "";
    description = "";

    imageRefId = null;
    #image = null;

    startDate = null;
    endDate = null;
    registrationEndDate = null;

    status = "DRAFT"; // enum EventStatuses DRAFT, PUBLISHED, PRIVATE
    statusHistory = []; // list of StatusHistory, historical changes to status

    isVirtual = false;
    allDay = false;
    capacity = null;
    link = null; // link to the event zoom meeting, google meet, etc.
    platform = null; // enum EventPlatforms ZOOM, GOOGLE_MEET, MICROSOFT_TEAMS, OTHER
    tags = []; // list of tags for the event

    testMode = false;

    programId = null;

    constructor(event) {
        if (isObjectNotEmpty(event)) {
            if (isStringNotEmpty(event.groupId)) { this.groupId = event.groupId; }
            if (isStringNotEmpty(event.parentEventId)) { this.parentEventId = event.parentEventId; }
            if (isStringNotEmpty(event.checkInId)) { this.checkInId = event.checkInId; }
            if (isStringNotEmpty(event.surveyId)) { this.surveyId = event.surveyId; }

            if (isListNotEmpty(event.breakoutGroupIds)) { this.breakoutGroupIds = event.breakoutGroupIds; }
            if (isListNotEmpty(event.childEventIds)) { this.childEventIds = event.childEventIds; }
            if (isListNotEmpty(event.participantIds)) { this.participantIds = event.participantIds; }
            if (isListNotEmpty(event.hostIds)) { this.hostIds = event.hostIds; }
            if (isListNotEmpty(event.reviewIds)) { this.reviewIds = event.reviewIds; }
            if (isListNotEmpty(event.socialIds)) { this.socialIds = event.socialIds; }

            if (isStringNotEmpty(event.location)) { this.location = event.location; }

            if (isNotNullOrUndefined(event.lastMessageAt)) { this.lastMessageAt = event.lastMessageAt; }
            if (isStringNotEmpty(event.lastMessageBy)) { this.lastMessageBy = event.lastMessageBy; }
            if (isBooleanTrue(event.isRead)) { this.isRead = true; }
            if (isNumberGreaterThanOrEqualToZero(event.unreadCount)) { this.unreadCount = event.unreadCount; }
            if (isNumberGreaterThanOrEqualToZero(event.messagesCount)) { this.messagesCount = event.messagesCount; }
            if (isListNotEmpty(event.messages)) { this.messages = event.messages; }

            if (isListNotEmpty(event.eventNotificationIds)) { this.eventNotificationIds = event.eventNotificationIds; }

            if (isStringNotEmpty(event.eventType)) { this.eventType = event.eventType; }
            if (isStringNotEmpty(event.name)) { this.name = event.name; }
            if (isStringNotEmpty(event.description)) { this.description = event.description; }

            if (isStringNotEmpty(event.imageRefId)) { this.imageRefId = event.imageRefId; }
            if (isNotNullOrUndefined(event.image)) { this.#image = event.image; }

            if (isNotNullOrUndefined(event.startDate)) { this.startDate = event.startDate; }
            if (isNotNullOrUndefined(event.endDate)) { this.endDate = event.endDate; }
            if (isNotNullOrUndefined(event.registrationEndDate)) { this.registrationEndDate = event.registrationEndDate; }

            if (isStringNotEmpty(event.status)) { this.status = event.status; }
            if (isListNotEmpty(event.statusHistory)) { this.statusHistory = event.statusHistory; }
            else if (isStringNotEmpty(this.status)) { this.statusHistory = StatusHistory.addNewStatus(this.status, []); }

            if (isBooleanTrue(event.isVirtual)) { this.isVirtual = event.isVirtual }
            if (isBooleanTrue(event.allDay)) { this.allDay = event.allDay }
            if (isNumberGreaterThanOrEqualToZero(event.capacity)) { this.capacity = event.capacity; }
            if (isStringNotEmpty(event.link)) { this.link = event.link }
            if (isStringNotEmpty(event.platform)) { this.platform = event.platform }
            if (isListNotEmpty(event.tags)) { this.tags = event.tags; }

            if (isBooleanTrue(event.testMode)) { this.testMode = true; }

            if (isStringNotEmpty(event.programId)) { this.programId = event.programId }
        }
    }

    toDto = () => {
        return {
            groupId: this.groupId,
            parentEventId: this.parentEventId,
            checkInId: this.checkInId,
            surveyId: this.surveyId,

            breakoutGroupIds: this.breakoutGroupIds,
            childEventIds: this.childEventIds,
            participantIds: this.participantIds,
            hostIds: this.hostIds,
            reviewIds: this.reviewIds,
            socialIds: this.socialIds,

            location: this.location,

            lastMessageAt: this.lastMessageAt,
            lastMessageBy: this.lastMessageBy,
            isRead: this.isRead,
            unreadCount: this.unreadCount,
            messagesCount: this.messagesCount,
            messages: this.messages,

            eventNotificationIds: this.eventNotificationIds,
            eventType: this.eventType,
            name: this.name,
            description: this.description,

            imageRefId: this.imageRefId,

            startDate: this.startDate,
            endDate: this.endDate,
            registrationEndDate: this.registrationEndDate,

            status: this.status,
            statusHistory: this.statusHistory,

            isVirtual: this.isVirtual,
            allDay: this.allDay,
            capacity: this.capacity,
            link: this.link,
            platform: this.platform,
            tags: this.tags,

            testMode: this.testMode,

            programId: this.programId
        }
    }

    isValid = () => {
        if (isStringEmpty(this.name)) {
            throw new Error('name is required.');
        }

        return true;
    }

    static getFileExt = (file) => {
        const lastDot = file.name.lastIndexOf('.');
        const ext = file.name.substring(lastDot + 1);

        return toLower(ext);
    }

    static addFile = async (file) => {
        if (isNotNullOrUndefined(file)) {
            try {
                const fileName = uuid() + '.' + this.getFileExt(file);
                const { storage, ref, uploadBytes } = await loadStorage();
                const storageRef = ref(storage, 'events/' + fileName);

                return await uploadBytes(storageRef, file);
            } catch (err) {
                console.log(err);
            }
        }

        return null;
    }

    static uploadImage = async (file) => {
        if (isNotNullOrUndefined(file)) {
            const uploadRes = await this.addFile(file);
            if (isObjectNotEmpty(uploadRes)) {
                return uploadRes.ref.fullPath;
            }
        }

        return null;
    }

    create = async () => {
        if (isNotNullOrUndefined(this.#image)) {
            this.imageRefId = await Event.uploadImage(this.#image);
        }

        if (this.isValid()) {
            return await create(Event.collectionName, this.toDto());
        }
    }

    static updateField = async (id, fieldName, newValue) => {
        if (isStringNotEmpty(id)) {
            return await updateField(Event.collectionName, id, fieldName, newValue);
        } else {
            throw new Error("id is required.");
        }
    }

    static updateFields = async (id, updatedFields) => {
        if (isStringNotEmpty(id)) {
            return await updateFields(Event.collectionName, id, updatedFields);
        } else {
            throw new Error("id is required.");
        }
    }

    static update = async (id, updatedEvent, oldObj) => {
        const updatedObj = new Event(updatedEvent);
        if (updatedObj.isValid() && id === updatedEvent.id) {
            if (isNotNullOrUndefined(updatedObj.#image)) {
                updatedObj.imageRefId = await this.uploadImage(updatedObj.#image);
            }
            const success = await update(Event.collectionName, id, updatedObj.toDto());
            if (isBooleanTrue(success)) {
                return { ...oldObj, ...updatedObj.toDto() };
            }
        } else {
            throw new Error('id and id field of the updated event must match.');
        }

        return null;
    }

    static delete = async (id) => {
        if (isStringNotEmpty(id)) {
            return await remove(Event.collectionName, id);
        } else {
            throw new Error("id is required.");
        }
    }

    static getById = async (id) => {
        if (isStringNotEmpty(id)) {
            return await getById(Event.collectionName, id);
        } else {
            throw new Error("id is required.");
        }
    }

    static getAll = async () => {
        return await getAll(Event.collectionName);
    }

    static getByField = async (fieldName, fieldValue, comparer = '==') => {
        return await getBySingleQuery(Event.collectionName, fieldName, fieldValue, comparer);
    }

    static search = async (searchCriteria) => {
        let { parentEventId, hostId, name, tags = [] } = searchCriteria;

        let queryConstraints = [];

        if (isStringNotEmptyOrZeroLength(parentEventId)) {
            queryConstraints.push(where('parentEventId', '==', parentEventId));
        }

        if (isStringNotEmptyOrZeroLength(hostId)) {
            queryConstraints.push(where('hostIds', 'array-contains', hostId));
        }
        if (isStringNotEmptyOrZeroLength(name)) {
            queryConstraints.push(where('name', '==', toLower(name)));
        }
        if (isListNotEmpty(tags)) {
            tags.forEach(tag => {
                if (isStringNotEmpty(tag)) {
                    queryConstraints.push(where('tags', 'array-contains', tag));
                }
            });
        }

        queryConstraints.push(orderBy('startDate', 'asc'));
        queryConstraints.push(orderBy('name', 'asc'));

        return await this.getByQueryConstraints(queryConstraints);
    }

    static getCount = async (queryParameters, dateFieldName = 'startDate') => {
        const { testMode, status, name, eventType, start, end, hostIds, participantIds, location, programId } = queryParameters;

        let queryConstraints = [];

        if (isBooleanTrue(testMode)) {
            queryConstraints.push(where('testMode', '==', true));
        } else if (isBooleanFalse(testMode)) {
            queryConstraints.push(where('testMode', '==', false));
        }

        if (isListNotEmpty(status)) {
            queryConstraints.push(where('status', 'in', status));
        } else if (isStringNotEmptyOrZeroLength(status)) {
            queryConstraints.push(where('status', '==', status));
        }

        if (isListNotEmpty(programId)) {
            queryConstraints.push(where('programId', 'in', programId));
        } else if (isStringNotEmptyOrZeroLength(programId)) {
            queryConstraints.push(where('programId', '==', programId));
        }

        if (isListNotEmpty(name)) {
            queryConstraints.push(where('name', 'in', name));
        } else if (isStringNotEmptyOrZeroLength(name)) {
            queryConstraints.push(where('name', '==', name));
        }

        if (isListNotEmpty(location)) {
            queryConstraints.push(where('location', 'in', location));
        } else if (isStringNotEmptyOrZeroLength(location)) {
            queryConstraints.push(where('location', '==', location));
        }

        if (isListNotEmpty(eventType)) {
            queryConstraints.push(where('eventType', 'in', eventType));
        } else if (isStringNotEmptyOrZeroLength(eventType)) {
            queryConstraints.push(where('eventType', '==', eventType));
        }

        if (isListNotEmpty(hostIds)) {
            queryConstraints.push(where('hostIds', 'array-contains-any', hostIds));
        } else if (isStringNotEmptyOrZeroLength(hostIds)) {
            queryConstraints.push(where('hostIds', 'array-contains', hostIds));
        }

        if (isListNotEmpty(participantIds)) {
            queryConstraints.push(where('participantIds', 'in', participantIds));
        } else if (isStringNotEmptyOrZeroLength(participantIds)) {
            queryConstraints.push(where('participantIds', '==', participantIds));
        }

        if (isNotNullOrUndefined(start)) {
            let startDate = asTimeZone(moment(new Date(start)), 'US/Pacific').startOf('day').utc().toDate();
            queryConstraints.push(where(dateFieldName, '>=', startDate));
        }

        if (isNotNullOrUndefined(end)) {
            let endDate = asTimeZone(moment(new Date(end)), 'US/Pacific').endOf('day').utc().toDate();
            queryConstraints.push(where(dateFieldName, '<=', endDate));
        }

        let q = query(collection(db, Event.collectionName), ...queryConstraints);

        const snapShot = await getCountFromServer(q);

        return snapShot.data().count;
    }

    static getPaginated = async (queryParameters, pageSize = 25, firstVisible, lastVisible, orderByField = 'startDate', dateFieldName = 'startDate') => {
        const { testMode, status, name, eventType, start, end, hostIds, participantIds, location, programId } = queryParameters;

        let queryConstraints = [];

        if (isBooleanTrue(testMode)) {
            queryConstraints.push(where('testMode', '==', true));
        } else if (isBooleanFalse(testMode)) {
            queryConstraints.push(where('testMode', '==', false));
        }

        if (isListNotEmpty(status)) {
            queryConstraints.push(where('status', 'in', status));
        } else if (isStringNotEmptyOrZeroLength(status)) {
            queryConstraints.push(where('status', '==', status));
        }

        if (isListNotEmpty(programId)) {
            queryConstraints.push(where('programId', 'in', programId));
        } else if (isStringNotEmptyOrZeroLength(programId)) {
            queryConstraints.push(where('programId', '==', programId));
        }

        if (isListNotEmpty(name)) {
            queryConstraints.push(where('name', 'in', name));
        } else if (isStringNotEmptyOrZeroLength(name)) {
            queryConstraints.push(where('name', '==', name));
        }

        if (isListNotEmpty(location)) {
            queryConstraints.push(where('location', 'in', location));
        } else if (isStringNotEmptyOrZeroLength(location)) {
            queryConstraints.push(where('location', '==', location));
        }

        if (isListNotEmpty(eventType)) {
            queryConstraints.push(where('eventType', 'in', eventType));
        } else if (isStringNotEmptyOrZeroLength(eventType)) {
            queryConstraints.push(where('eventType', '==', eventType));
        }

        if (isListNotEmpty(hostIds)) {
            queryConstraints.push(where('hostIds', 'array-contains-any', hostIds));
        } else if (isStringNotEmptyOrZeroLength(hostIds)) {
            queryConstraints.push(where('hostIds', 'array-contains', hostIds));
        }

        if (isListNotEmpty(participantIds)) {
            queryConstraints.push(where('participantIds', 'in', participantIds));
        } else if (isStringNotEmptyOrZeroLength(participantIds)) {
            queryConstraints.push(where('participantIds', '==', participantIds));
        }

        if (isNotNullOrUndefined(start)) {
            let startDate = asTimeZone(moment(new Date(start)), 'US/Pacific').startOf('day').utc().toDate();
            queryConstraints.push(where(dateFieldName, '>=', startDate));
        }

        if (isNotNullOrUndefined(end)) {
            let endDate = asTimeZone(moment(new Date(end)), 'US/Pacific').endOf('day').utc().toDate();
            queryConstraints.push(where(dateFieldName, '<=', endDate));
        }

        let q = null;
        if (isObjectNotEmpty(firstVisible)) {
            q = query(collection(db, Event.collectionName), ...queryConstraints, orderBy(orderByField, 'asc'), orderBy('__name__', 'asc'), limitToLast(pageSize), endBefore(firstVisible[orderByField], firstVisible['id']));
        } else if (isObjectNotEmpty(lastVisible)) {
            q = query(collection(db, Event.collectionName), ...queryConstraints, orderBy(orderByField, 'asc'), orderBy('__name__', 'asc'), limit(pageSize), startAfter(lastVisible[orderByField], lastVisible['id']));
        } else {
            q = query(collection(db, Event.collectionName), ...queryConstraints, orderBy(orderByField, 'asc'), orderBy('__name__', 'asc'), limit(pageSize));
        }

        let snapshot = await getDocs(q);
        return snapshot.docs.map((doc) => {
            return {
                id: doc.id,
                ...doc.data()
            };
        });
    }

    static get = async (queryParameters, dateFieldName = 'startDate') => {
        let allRecords = [];
        try {
            let next = null;
            let totalPages = 0;

            let totalCount = await this.getCount(queryParameters, dateFieldName);
            totalPages = Math.ceil(totalCount / 10000.0);
            // console.log('totalCount: ' + totalCount);
            // console.log('totalPages: ' + totalPages);
            let pages = [];
            for (let i = 0; i < totalPages; i++) {
                pages.push(i + 1);
            }
            for (const page of pages) {
                // console.log('starting page ' + page);

                let list = await this.getPaginated(queryParameters, 10000, null, next, dateFieldName, dateFieldName);

                // console.log(list.length);
                allRecords = [...allRecords, ...list];

                // console.log(allRecords.length);

                // console.log('go to next page');
                next = list[list.length - 1];
            }
        } catch (error) {
            console.log(error);
        }

        return allRecords;
    }
};

export default Event;